module.exports = __webpack_public_path__ + "img/botao-acao.fee01f94.png";